<div class="col-md-12">
  <app-nutrition
    [memberId]="memberId"
    [startDate]="nutritionStartDate"
    [endDate]="nutritionEndDate">
  </app-nutrition>
  
  <div class="col-md-12 mt-4 foodlog-section-align">
    <app-all-food-logs
      [memberId]="memberId"
      [memberName]="memberName"
      [startDate]="nutritionStartDate"
      [endDate]="nutritionEndDate"
      [selectedFoodLogId]="selectedFoodLogId"
      [selectedNutritionType]="selectedNutritionType"
      (refresh)="onFoodDeleted()">
    </app-all-food-logs>
  </div>
</div>